import { render, staticRenderFns } from "./ButtonToTop.vue?vue&type=template&id=5d69da1b&scoped=true"
import script from "./ButtonToTop.vue?vue&type=script&lang=ts"
export * from "./ButtonToTop.vue?vue&type=script&lang=ts"
import style0 from "./ButtonToTop.scss?vue&type=style&index=0&id=5d69da1b&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d69da1b",
  null
  
)

export default component.exports